import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/components/MainLayout'
import { getCookie } from '@/utils/cookie'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MainLayout',
      redirect: getCookie('index'),
      component: MainLayout,
      children: [
        {
          name: 'testUI', path: '/test/testui',
          component: _ => import('@/views/test/testui'),
        },{
          name: '企业首页', path: '/admin/home/enterprise/index',
          component: _ => import('@/views/home/enterprise/index'),
        }, {
          name: '平台首页', path: '/admin/home/platform/index',
          component: _ => import('@/views/home/platform/index'),
        }, {
          name: '项目众包', path: '/admin/basic/project/list',
          component: _ => import('@/views/basic/project/list')
        }, {
          name: '佣金结算单管理', path: '/admin/statAndQuery/statement/list',
          component: _ => import('@/views/statAndQuery/statement/list')
        }, {
          name: '企业管理', path: '/admin/basic/enterprise/list',
          component: _ => import('@/views/basic/enterprise/list')
        },{
          name: '子单元管理', path: '/admin/basic/enterprise/subunitlist',
          component: _ => import('@/views/basic/enterprise/subunitlist')
        },{
          name: '用户管理', path: '/admin/system/user/list',
          component: _ => import('@/views/system/user/list')
        },{
          name: '承办行管理', path: '/admin/basic/banks/list',
          component: _ => import('@/views/basic/banks/list')
        },{
          name: '合同管理', path: '/admin/basic/contract/list',
          component: _ => import('@/views/basic/contract/list'),
        },{
          name: '合同资料审核', path: '/admin/basic/contract/contractInfoAudit/list',
          component: _ => import('@/views/basic/contract/contractInfoAudit/list'),
        }, {
          name: '未开发票', path: '/admin/invoice/invEnterpriseUninvoicedHis/list',
          component: _ => import('@/views/invoice/invEnterpriseUninvoicedHis/list'),
        }, {
          name: '开票处理', path: '/admin/invoice/enterpriseAppliedInvoice/list',
          component: _ => import('@/views/invoice/enterpriseAppliedInvoice/list'),
        }, {
          name: '历史发票', path: '/admin/invoice/enterpriseInvoiceHistories/list',
          component: _ => import('@/views/invoice/enterpriseInvoiceHistories/list'),
        }, {
          name: '风控审核管理', path: '/admin/settlement/statementAuditOncoming/list',
          component: _ => import('@/views/settlement/statementAuditOncoming/list')
        }, {
          name: '个体经营者查询', path: '/admin/basic/selfEmployed/list',
          component: _ => import('@/views/basic/selfEmployed/selfEmployedList')
        }, {
          name: '企业注册数量统计', path: '/admin/statAndQuery/statisReport/enterpriseRegistrationStatis',
          component: _ => import('@/views/statAndQuery/statisReport/enterpriseRegistrationStatis')
        }, {
          name: '个体经营者注册数量统计', path: '/admin/statAndQuery/statisReport/selfEmployedRegistrationStatis',
          component: _ => import('@/views/statAndQuery/statisReport/selfEmployedRegistrationStatis')
        }, {
          name: '企业城市分布统计', path: '/admin/statAndQuery/statisReport/enterpriseCitySpread',
          component: _ => import('@/views/statAndQuery/statisReport/enterpriseCitySpread')
        }, {
          name: '个体经营者城市分布统计', path: '/admin/statAndQuery/statisReport/selfEmployedCitySpread',
          component: _ => import('@/views/statAndQuery/statisReport/selfEmployedCitySpread')
        }, {
          name: '企业贡献率统计', path: '/admin/statAndQuery/statisReport/enterpriseContributionRate',
          component: _ => import('@/views/statAndQuery/statisReport/enterpriseContributionRate')
        }, {
          name: '企业充值记录查询', path: '/admin/settlement/enterprisesRecharge/list',
          component: _ => import('@/views/statAndQuery/statisReport/rechargeRecordStatis')
        },{
          name: '支出记录查询', path: '/admin/settlement/expenditureRecord/list',
          component: _ => import('@/views/statAndQuery/statisReport/expenditureRecord')
        }, {
          name: '众包项目管理', path: '/admin/statAndQuery/project/list',
          component: _ => import('@/views/statAndQuery/project/list')
        }, {
          name: '订单任务管理', path: '/admin/settlement/orderTask/list',
          component: _ => import('@/views/settlement/orderTask/list')
        },{
          name: '提现列表管理', path: '/admin/statAndQuery/withdraw/list',
          component: _ => import('@/views/statAndQuery/withdraw/list')
        }, {
          name: '禁止人员管理', path: '/admin/basic/forbiddenPersons/list',
          component: _ => import('@/views/basic/forbiddenPersons/list')
        }, {
          name: '快递公司管理', path: '/admin/basic/courierCompanies/list',
          component: _ => import('@/views/basic/courierCompanies/list')
        }, {
          name: '品目税率管理', path: '/admin/invoice/enterpriseInvoiceItems/list',
          component: _ => import('@/views/invoice/enterpriseInvoiceItems/list')
        }
      ]
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: () => import('@/views/login/login'),
    // },
    {
      name: 'forgetPassword', path: '/forgetPassword',
      component: _ => import('@/views/forgetPassword/forgetPassword'),
    },
    {
      path: '/401',
      hidden: true,
      name: '没有权限',
      component: () => import('@/views/errorPage/401'),
    }, {
      path: '/404',
      hidden: true,
      name: '没有该页面',
      component: () => import('@/views/errorPage/404'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js